var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfo = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4016 8.00156C14.4016 4.46716 11.536 1.60156 8.00156 1.60156C4.46716 1.60156 1.60156 4.46716 1.60156 8.00156C1.60156 11.536 4.46716 14.4016 8.00156 14.4016C11.536 14.4016 14.4016 11.536 14.4016 8.00156ZM7.20156 10.4016C7.20156 10.8434 7.55973 11.2016 8.00156 11.2016C8.44339 11.2016 8.80156 10.8434 8.80156 10.4016V8.80156C8.80156 8.35973 8.44339 8.00156 8.00156 8.00156C7.55973 8.00156 7.20156 8.35973 7.20156 8.80156V10.4016ZM7.20156 5.60156C7.20156 6.04339 7.55973 6.40156 8.00156 6.40156C8.44339 6.40156 8.80156 6.04339 8.80156 5.60156C8.80156 5.15973 8.44339 4.80156 8.00156 4.80156C7.55973 4.80156 7.20156 5.15973 7.20156 5.60156Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.9d67c87f.svg";
export { ForwardRef as ReactComponent };